import { Typography, Toolbar, Link } from '@mui/material'
import React, { useEffect, useState, useRef } from 'react'
import { Link as RouterLink } from 'react-router-dom';
import chaticon from '../Image/chat-icon.svg';
import Chatform from '../Component/Chatform';
import Chatsms from '../Component/Chatsms';
import { useLanguage } from '../context/LanguageContext';
import paan from "../Image/pan.svg";
import panpatta from "../Image/panpatta.svg";
import smoke from "../Image/smoke.svg";
import hookah from "../Image/smoke.svg";
import alcohol from "../Image/smoke.svg";
import gutka from "../Image/gutka.svg";
import ciggi from "../Image/cigrate.svg";
import insidecheck from"../Image/inside-check.jpg";
import tounge from"../Image/tounge.jpg";
import belowtounge from"../Image/below tounge.jpg";
import gums from"../Image/gums.jpg";
import roof from"../Image/roof-of-mouth.jpg";
import lips from"../Image/lips.jpg";
import { useMode } from "../context/modeContext";

import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";


const Chatbox = () => {
  const { t } = useLanguage();
  const chatBodyRef = useRef(null); // <-- NEW
  const [subQuestionStack, setSubQuestionStack] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();   
  const receivedNumber = location.state?.number;
  const name = location.state?.name;
  const dob = location.state?.dob;
  const gender = location.state?.gender;
  const address = location.state?.address;

  const { mode } = useMode();



  const botQuestions = [
    {
       text: `${t('q_hii')} ${name} ${t('q_namaskar')}`,
      type: "buttons",
      options: [
        t('b_Continue'),
      ]
    },
    {
    
      
      text: t('q_smoke'),
      type: "yesno",
      subquestion: {
        // 1st sub question
        question1: {
          text: t('q_smoke_type'),
          type: "img_checkbox",
          imgs: [
            t(ciggi),
            t(smoke),
            t(ciggi),
            t(smoke),
          ],
          options: [
            t('opt_cigarette'),
            t('opt_bidi'),
            t('opt_cigar'),
            t('opt_hookah'),

          ],
          //end of first question if yes
        },
        question2: {
          text: t('q_smoke_duration'),
          type: "checkbox",
    
        options: [
          t('opt_smoke_dur1'),
          t('opt_smoke_dur2'),
          t('opt_smoke_dur3')
     
        ]
        },
        question3: {
          text: t('q_smoke_freq'),
          type: "img_checkbox",
          imgs: [
            t(panpatta),
            t(paan),
            t(ciggi),
            t(smoke),
          ],
          options: [
            t('opt_occ'),
            t('opt_1_5'),
            t('opt_6_10'),
            t('opt_10_plus'),
          ]
        },

      },


    },

    //2nd sub quesiton

    {
      text: t('q_chew'),
      type: "yesno",
      subquestion: {
        question1: {
          text: t('q_chew_duration'),
           type: "checkbox",
    
        options: [
          t('opt_smoke_dur1'),
          t('opt_smoke_dur2'),
          t('opt_smoke_dur3')
     
        ]
        },
        question2: {
          text: t('q_chew_freq'),
          type: "img_checkbox",
          imgs: [
            t(alcohol),
            t(hookah),
            t(gutka),
            t(smoke),
          ],
          options: [
            t('opt_occ'),
            t('opt_1_5'),
            t('opt_6_10'),
            t('opt_10_plus'),
          ]
        },
      }
    },


    // 3rd sub quesiton

    {
      text: t('q_alcohol'),
      type: "yesno",
      subquestion: {
        question1: {
          text: t('q_alcohol_duration'),
          type: "checkbox",
    
        options: [
          t('opt_smoke_dur1'),
          t('opt_smoke_dur2'),
          t('opt_smoke_dur3')
     
        ]
        },
        question2: {
          text: t('q_alcohol_freq'),
          type: "img_checkbox",
          imgs: [
            t(alcohol),
            t(hookah),
            t(gutka),
            t(smoke),
          ],
          options: [
            t('opt_occ'),
            t('opt_1_5'),
            t('opt_6_10'),
            t('opt_10_plus'),
          ]
        },
      },
    },


    {
      text: t('q_symptoms'),
      type: "checkbox",
    
      options: [
        t('sym_none'),
        t('sym_burning'),
        t('sym_pain'),
        t('sym_ulcers'),
        t('sym_white'),
        t('sym_red'),
        t('sym_mixed'),
        t('sym_thick'),
        t('sym_open_diff'),
        t('sym_chew_diff'),
        t('sym_swallow_diff'),
        t('sym_dec_open'),
        t('sym_stiff'),
        t('sym_dry'),
        t('sym_taste'),
        t('sym_bleed'),
        t('sym_loose'),
        t('sym_irritation')
      ]

    },
    {
      text: t('q_location'),
     type: "img_checkbox",
          imgs: [
            t(),
            t(insidecheck),
            t(tounge),
            t(belowtounge),
            t(gums),
            t(roof),
            t(lips),
          ]
   ,options: [
        t('sym_none'),
        t('opt_inside_cheek'),
        t('opt_tongue'),
        t('opt_below_tongue'),
        t('opt_gums'),
        t('opt_roof_mouth'),
        t('opt_lips'),
      ],

      subquestion: {
        text: t('q_side'),
        type: "checkbox",

        options: [
          t('opt_right'),
          t('opt_left'),
          t('opt_both'),
        ]
      }
    },

    // {
    //   text: "Upload something",
    //   type: "file"
    // },


    {
      text: t('q_upload_photo'),
      type: "camera"
    },

    {
      text: t('q_result'),
      type: "result"
    },
  ];


  const [chatHistory, setChatHistory] = useState([]);
  const [questionIndex, setQuestionIndex] = useState(0);

  useEffect(() => {
    setChatHistory([{ ...botQuestions[0], sender: "bot" }]);
  }, []);

  useEffect(() => {
    if (chatBodyRef.current) {
      chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
    }
  }, [chatHistory]);
// useEffect(() => {
//   const answeredQuestions = chatHistory.filter(
//     chat => chat.sender === "bot" && chat.answered
//   );

//   console.log("===== ALL ANSWERS =====");
//   answeredQuestions.forEach(q => {
//     console.log("Question:", q.text);
//     console.log("Answer:", q.userAnswer);
//   });
// }, [chatHistory]);

  const handleUserMessage = (message, msgIndex) => {
    const currentChat = chatHistory[msgIndex];

    // mark the current bot question as answered
    setChatHistory(prev =>
      prev.map((chat, index) =>
        index === msgIndex && chat.sender === "bot"
          ? { ...chat, answered: true, userAnswer: message }
          : chat
      )
    );

    // add user's message to chat
    setChatHistory(prev => [
      ...prev,
      { text: message, sender: "user" }
    ]);


    if (currentChat.type === "yesno" && message.toLowerCase() === "yes" && currentChat.subquestion) {
      const subQs = Object.values(currentChat.subquestion);
      setSubQuestionStack(subQs);
      const firstSubQ = subQs[0];
      setTimeout(() => {
        setChatHistory(prev => [
          ...prev,
          { ...firstSubQ, sender: "bot" }
        ]);
      }, 300);
    } else if (subQuestionStack.length > 0) {
      // we're in subquestion flow
      const [, ...rest] = subQuestionStack;
      setSubQuestionStack(rest);

      if (rest.length > 0) {
        setTimeout(() => {
          setChatHistory(prev => [
            ...prev,
            { ...rest[0], sender: "bot" }
          ]);
        }, 300);
      } else if (questionIndex + 1 < botQuestions.length) {
        // subquestion stack finished, move to next main question
        setTimeout(() => {
          setChatHistory(prev => [
            ...prev,
            { ...botQuestions[questionIndex + 1], sender: "bot" }
          ]);
          setQuestionIndex(prev => prev + 1);
        }, 300);
      }
    } else if (questionIndex + 1 < botQuestions.length) {
      // no subquestion, just move to next main question
      setTimeout(() => {
        setChatHistory(prev => [
          ...prev,
          { ...botQuestions[questionIndex + 1], sender: "bot" }
        ]);
        setQuestionIndex(prev => prev + 1);
      }, 300);
    } 

    if (message === "SHOW RESULT") {
      setChatHistory(prev => {
        const updatedHistory = prev.map((chat, index) =>
          index === msgIndex && chat.sender === "bot"
            ? { ...chat, answered: true, userAnswer: message }
            : chat
        );
    
        const answers = updatedHistory
          .filter(chat => chat.sender === "bot" && chat.answered)
          .map(chat => ({
            question: chat.text,
            answer: chat.userAnswer
          }));
    
        console.log("Navigating with:", answers);
        const images = answers
        .map(a => a.answer)
        .filter(ans => typeof ans === "string" && ans.startsWith("/images"));
        navigate("/result", {
          state: {
            answers,
            name,
            dob,
            gender,
            address,
            phone: receivedNumber,
            images
          }
        });
    
        return updatedHistory;
      });
    
      return;
    }
    
  };



  const getAllAnswers = () => {
    return chatHistory
      .filter(chat => chat.sender === "bot" && chat.answered)
      .map(chat => ({
        question: String(chat.text),
        answer: String(chat.userAnswer)
      }));
  };
  return (
    <Toolbar>
      <div className='containner'>

        <div className="chat-bot-popupe">

          {/* chat header */}
          <div className="chat-header">
            <div className="header-info">
              <img src={chaticon} alt='img' />
              <Typography variant='h2' className='logo-text'>{t('chatbox_title')}</Typography>
            </div>

            <div className="chat-btn"><Link component={RouterLink} to="/Paitentsform" className='back-btn' sx={{ marginTop: '30px' }}>{t('back_btn')}</Link></div>


          </div>
          {/* chat body */}
          <div className="chat-body" ref={chatBodyRef}>
            {chatHistory.map((chat, index) => (
              <Chatsms
                key={index}
                chat={chat}
                onOptionSelect={(msg) => handleUserMessage(msg, index)}
                getAllAnswers={getAllAnswers}
              />
            ))}
          </div>

          {/* chat footer */}

          <div className="chat-footer">
            <Chatform onSend={handleUserMessage} />
            <div className='reset-btn'>
              <Link href="#" className='reset-btn'>{t('reset_btn')}</Link>
            </div>
          </div>

        </div>
        {/* <div className='right-side accordian-right-side'>
          <div className='custom-accord'>

            <div className='result-details-wrapper'>
              <input
                type="date"
                placeholder='Message....'
                className="message-input"
                required

              />
              <Typography variant='h2'>{t('history_title')}</Typography>
              <Typography variant='body1'>{t('history_text')}</Typography>
            </div>

          </div>

        </div> */}

      </div>
    </Toolbar>
  )
}

export default Chatbox;

